import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'

// 手机调试开关：网址带 ?debug=1 时加载手机版控制台（eruda），按需动态加载，走本站资源（国内也稳），平时不影响。
if (typeof window !== 'undefined' && /[?&]debug=1/.test(window.location.search)) {
  import('eruda').then(m => m.default.init()).catch(() => {})
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
})

// Detect which app to render:
// - Dev: add ?__app=broadcast to URL to preview broadcast app
// - Prod: any domain not in MAIN_DOMAINS renders BroadcastApp
const MAIN_DOMAINS = new Set([
  'kaigong.bendibang.com',
  'www.kaigong.bendibang.com',
  'localhost',
  '127.0.0.1',
])

// 客户门户子域名（*.portal.bendibang.com）渲染主 App（/portal 路由在主 App 里），
// 不能落进下面「非主域名=播报」的兜底，否则会跳到播报页。
const isPortalHost = /\.portal\.bendibang\.com$/.test(window.location.hostname)

const isBroadcastApp =
  !isPortalHost &&
  (window.location.pathname.startsWith('/bcast') ||
    (import.meta.env.PROD && !MAIN_DOMAINS.has(window.location.hostname)))

// 门户子域名访问根路径时，直接进门户（避免落到员工登录页）
if (isPortalHost && window.location.pathname === '/') {
  window.history.replaceState(null, '', '/portal')
}

async function boot() {
  const { default: RootApp } = isBroadcastApp
    ? await import('./BroadcastApp')
    : await import('./App')

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <RootApp />
    </React.StrictMode>,
  )
}

boot()
